module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "zigbee-hub-add-remote"
  }, [_c('div', {
    staticClass: "zigbee-hub-add-remote-searching"
  }, [_c('iconfont-loading', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearching),
      expression: "isSearching"
    }],
    attrs: {
      "size": "1rem",
      "color": "#269aff"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isSearchDone),
      expression: "isSearchDone"
    }],
    staticClass: "iconfont icon-success"
  }), _vm._v(" "), _c('h3', [_vm._v("已添加3个设备")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "next-btn2"
  }, [_c('button', {
    staticClass: "btn-square-primary",
    on: {
      "click": _vm.doneClick
    }
  }, [_vm._v("完成")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "zigbee-remote-list"
  }, [_c('li', [_c('img', {
    staticClass: "zigbee-remote-list-img",
    attrs: {
      "src": require("../../../assets/img/device/icon_zigbeeCurtainMoto.png")
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "zigbee-remote-list-name"
  }, [_vm._v("巧克力窗帘电机")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "zigbee-remote-list-img",
    attrs: {
      "src": require("../../../assets/img/device/icon_zigbeeCurtainMoto.png")
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "zigbee-remote-list-name"
  }, [_vm._v("巧克力窗帘电机")])]), _vm._v(" "), _c('li', [_c('img', {
    staticClass: "zigbee-remote-list-img",
    attrs: {
      "src": require("../../../assets/img/device/icon_zigbeeCurtainMoto.png")
    }
  }), _vm._v(" "), _c('strong', {
    staticClass: "zigbee-remote-list-name"
  }, [_vm._v("巧克力窗帘电机")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bfab27b"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/connect/zigbee/Hub_addRemote.vue
// module id = 888
// module chunks = 1